export class ApplicantDetails {
  public firstName: string;
  public lastName: string;
  public function: string;
  public email: string;
  public phone: string;
  public explanation: string;

  constructor(data: Partial<ApplicantDetails> = {}) {
    this.firstName = data?.firstName ?? '';
    this.lastName = data?.lastName ?? '';
    this.function = data?.function ?? '';
    this.email = data?.email ?? '';
    this.phone = data?.phone ?? '';
    this.explanation = data?.explanation ?? '';
  }

  public static createFromApi(data: any = {}): ApplicantDetails {
    return new ApplicantDetails({
      firstName: data?.firstName ?? '',
      lastName: data?.lastName ?? '',
      function: data?.function ?? '',
      email: data?.email ?? '',
      phone: data?.phone ?? data?.phoneNumber ?? '',
      explanation: data?.explanation ?? '',
    });
  }

  public processForApi(): Record<string, any> {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
      function: this.function,
      email: this.email,
      phone: this.phone,
      explanation: this.explanation,
    };
  }
}
